// var $ = require("jquery");
window.scrollLoad = true;
window.page_num = 1;

const NORESULTHTML = `
<div class="row mt-5 text-center mb-5 bg-body">
  <div class="col-12">
    <h3 class="h5">Hierfür gibt es aktuell keine Ergebnisse.</h3>
    <div class="icon-smiley-sleepy mt-3 fs-150px"></div>
  </div>
</div>`;
const SPINNER = `
<div id="list_loader" class="row mt-3 bg-body">
  <div class="col-12 justify-content-center text-center">
    <div class="spinner-border text-primary text-center" role="status"></div>
  </div>
</div>`;
const EMP_SPINNER = `<div class="col-12 text-center py-3"><div class="spinner-border text-primary" role="status"></div></div>`;

$(document).on('turbo:load', async function() {
    window.scrollLoad = true;
    window.page_num = 1;
    $(window).scroll(async function() {
      if($('#accordionEmployees').length == 1) {
        if (window.scrollLoad && (window.location.href.indexOf("dienste-und-kontakte/kontakte") > -1) && $(window).scrollTop() >= $(document).height() - $(window).height() - 300) {
          $("#accordionEmployees").append(SPINNER);
          window.scrollLoad = false;
          window.page_num = window.page_num + 1;
          let suggestions = await loadEmployees($(".employees_search").val(), window.page_num);
          const employeeSet = new Set();
          $.each(suggestions.data.data, function(key, employee) {
            if (employeeSet.has(employee.id)) return;
            employeeSet.add(employee.id);
            $("#accordionEmployees").append(generateContactEmployeeHeader(employee));
          });
          if (suggestions.data.data.length < 1) {
            window.scrollLoad = false;
            !$("#accordionEmployees").html().includes("Alle Ergebnisse gesehen") && $("#accordionEmployees").append(`<p class="fs-small text-black-50 text-center mt-3 pb-3">Alle Ergebnisse gesehen</p>`);
          } else {
            window.scrollLoad = true;
          }
          $("#list_loader").remove();
        }
      }
      if($('#accordionServices').length == 1){
        /// Entries
        if (window.scrollLoad && (window.location.href.indexOf("dienste-und-kontakte/dienste") > -1) && $(window).scrollTop() >= $(document).height() - $(window).height() - 300) {
          $("#accordionServices").append(SPINNER);
          window.scrollLoad = false;
          window.page_num = window.page_num + 1;
          let suggestions = await loadServices($(".entries_search").val(), window.page_num);
          $.each(suggestions.data, function(key, service) {
            let employeeHtml = '';
            $.each(service.employees, function(key, employee) {
              employeeHtml += generateServiceEmployeeHeader(employee, service["id"]);
            });
            $("#accordionServices").append(generateEntry(service, employeeHtml));
          });
          if (suggestions.data.length < 1) {
            window.scrollLoad = false;
            !$("#accordionServices").html().includes("Alle Ergebnisse gesehen") && $("#accordionServices").append(`<p class="fs-small text-black-50 text-center mt-3 pb-3">Alle Ergebnisse gesehen</p>`);
          } else {
            window.scrollLoad = true;
          }
          $("#list_loader").remove();
        }
      }
    });
});

async function loadServicesCount(search) {
    const response = await fetch(`/get-all-search-count?search=${search}`,{
        method: 'get',
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
        },
    }).then(res => res.clone().json())
    return response;
}
async function loadEmployees(search, page_count) {
    const baseUrl = "/get-lwconnect-employees";
    const params = new URLSearchParams();
    if (search) {
        params.append("search", search);
    } else {
        const letter = getUrlParameter("letter");
        if (letter) {
            params.append("letter", letter);
        }
    }
    if (page_count > 1) {
        params.append("page", page_count.toString());
    }
    // if (!search && page_count <= 1) {
    //     return;
    // }
    const url = `${baseUrl}?${params.toString()}`;
    const response = await fetch(url, {
        method: "GET",
        headers: {
            "X-Requested-With": "XMLHttpRequest"
        }
    });
    const responseData = await response.json();
    return responseData;
}


async function loadServices(search, page_count) {
    let url_ =  `/get-lwconnect-entries?`;
    if (search !== "") {
        url_ += `search=${search}`;
    }
    if (page_count > 1) {
        url_ += `${search !== "" ? '&' : ''}page=${page_count}`;
    }
    // if (search === "" && page_count <= 1) {
    //     return;
    // }
    const response = await fetch(url_, {
        method: 'get',
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
        },
    }).then(res => res.clone().json());
    return response;
}
function getUrlParameter(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
}
// Function to generate department HTML
function generateDepartments(departments) {
  return departments.map(dept => `<p class="mb-0">${dept["name"]}</p>`).join('');
}
// Function to generate entry HTML
function generateEntries(entries, employeeId, serviceId) {
  return entries.map(entry => {
    let uriLink = entry["uri"] ? `<div class="col-12 mb-1"><a class="align-items-center bg-footer br-0 border btn btn-lg d-flex d-grid justify-content-between" href="${entry["uri"]}">
                                  <p class="mb-0">${entry["name"]} - Direktlink zum Antrag</p>
                                  <div class="fs-small icon-arrow-right-1"></div>
                                </a></div>` : '';
    return `<div class="accordion-item bg-white border-0">
              <h2 class="accordion-header" id="entryheading${entry["id"]}${employeeId}${serviceId}">
                <button aria-controls="entrycollapse${entry["id"]}${employeeId}${serviceId}" aria-expanded="true" class="employee-button accordion-button collapsed pt-2 pb-2 p-0 mb-2 mt-2 text-gray" data-bs-target="#entrycollapse${entry["id"]}${employeeId}${serviceId}" data-bs-toggle="collapse" type="button">
                ${entry["name"]}
                </button>
              </h2>
              <div aria-labelledby="entryheading${entry["id"]}${employeeId}${serviceId}" class="accordion-collapse collapse" data-bs-parent="#accordionEmployeesServices${employeeId}${serviceId}" id="entrycollapse${entry["id"]}${employeeId}${serviceId}">
                <div class="accordion-body row pt-0">
                  ${uriLink}
                  <div class="col-12">
                    <p class="mb-0">${entry["description"]}</p>
                  </div>
                </div>
              </div>
              <hr class="mt-0 mb-0 border-dark">
            </div>`;
  }).join('');
}
function generateEntry(service, employeeHtml) {
  return (`<div class="accordion-item bg-footer">
 <h2 class="accordion-header" id="heading${service["id"]}">
    <button aria-controls="collapse${service["id"]}" aria-expanded="false" class="accordion-button bg-footer collapsed" data-bs-target="#collapse${service["id"]}" data-bs-toggle="collapse" type="button">
    ${service["name"]}
    </button>
 </h2>
 <div aria-labelledby="heading${service["id"]}" class="accordion-collapse collapse" data-bs-parent="#accordionServices" id="collapse${service["id"]}" style="">
    <div class="accordion-body row">` +
      // present the external link only if entry[f_online_service] == true
      (
        (service["f_online_service"]) ?
          `<div class="col-12 ps-2 mb-3">
              <a class="align-items-center bg-gray-400 br-0 btn d-flex d-grid gap-2 justify-content-between pt-2" target="_blank" href="${service["uri"]}">
                 <span class="text-start">${service["name"]} - Direktlink zum Antrag</span>
                 <div class="icon-arrow-right-1 fs-smaller"></div>
              </a>
           </div>` : ``
      ) +
       `<div class="col-12">
          <p>Ansprechpartner:</p>
       </div>
       <div class="col-12 pe-0">
          <div class="accordion bg-footer" id="accordionServiceEmployees${service["id"]}">
             <div class="box border-0 shadow-none bg-footer mb-0">
                <div class="box-middle">` + employeeHtml +`
                </div>
             </div>
          </div>
       </div>
    </div>
 </div>
</div>`)
}


// Employee row for the Dienste ("services") accordion: only the name header plus
// an empty, lazily-filled body. The full contact card + Abteilungen + Leistungen
// are fetched per employee on first expand (see the show.bs.collapse handler
// below), which keeps the initial Dienste payload tiny even for employees with
// 100+ Leistungen. Must mirror the server markup in verwaltung/dienste.html.haml.
function generateServiceEmployeeHeader(employee, serviceId) {
  return `<div class="accordion-item bg-white border-0">
      <h2 class="accordion-header" id="heading${employee["id"]}${serviceId}">
        <button aria-controls="collapse${employee["id"]}${serviceId}" aria-expanded="false" class="accordion-button collapsed bg-footer pt-3 pb-3 header-button employee-button" data-bs-target="#collapse${employee["id"]}${serviceId}" data-bs-toggle="collapse" type="button">
        ${employee["first_name"]} ${employee["last_name"]}
        </button>
      </h2>
      <div aria-labelledby="heading${employee["id"]}${serviceId}" class="accordion-collapse collapse" data-bs-parent="#accordionServiceEmployees${serviceId}" id="collapse${employee["id"]}${serviceId}">
        <div class="accordion-body row pt-0 lazy-employee" data-employee-id="${employee["id"]}" data-service-id="${serviceId}" data-loaded="false"></div>
      </div>
    </div>`;
}

// Employee row for the Kontakte accordion: name header + empty lazy body (parent
// #accordionEmployees, no serviceId). Details are fetched on first expand, same as
// the Dienste rows. Mirrors the server markup in verwaltung/kontakte.html.haml.
function generateContactEmployeeHeader(employee) {
  const eid = employee["id"];
  return `<div class="box border-0 shadow-none bg-footer mb-0"><div class="box-middle">
      <div class="accordion-item bg-white border-0">
        <h2 class="accordion-header" id="heading${eid}">
          <button aria-controls="collapse${eid}" aria-expanded="false" class="accordion-button collapsed bg-footer pt-2 pb-2 header-button" data-bs-target="#collapse${eid}" data-bs-toggle="collapse" type="button">
          ${employee["first_name"]} ${employee["last_name"]}
          </button>
        </h2>
        <div aria-labelledby="heading${eid}" class="accordion-collapse collapse" data-bs-parent="#accordionEmployees" id="collapse${eid}">
          <div class="accordion-body row pt-0 lazy-employee" data-employee-id="${eid}" data-service-id="" data-loaded="false"></div>
        </div>
      </div>
    </div></div>`;
}

// Inner HTML of an employee's accordion body (contact details, Abteilungen,
// Leistungen), injected on demand into a .lazy-employee container. Mirrors the
// body verwaltung/dienste.html.haml used to render inline for every employee.
// Every field is guarded so a missing array never throws (the /employees/:id
// endpoint may return empty arrays, unlike the list endpoint).
function generateEmployeeBody(employee, serviceId) {
  const eid = employee["id"];
  const addr = (employee["addresses"] || [])[0] || {};
  const phone = ((employee["phonenumbers"] || [])[0] || {})["name"] || "";
  const fax = ((employee["faxnumbers"] || [])[0] || {})["name"] || "";
  const email = ((employee["emailaddresses"] || [])[0] || {})["name"] || "";
  const website = ((employee["websites"] || [])[0] || {})["name"] || "";
  const departments = generateDepartments(employee["departments"] || []);
  const entries = generateEntries(employee["entries"] || [], eid, serviceId);
  const org = $(".add-to-contact").first().data("organization")
              || $("h2").first().text().split(" ").slice(1).join(" ");

  return `
    <div class="col-12">
      <p class="mb-0">Telefon: ${phone}</p>
      <p>Fax: ${fax}</p>
    </div>
    <hr class="mt-1 border mb-1">
    <div class="col-12">
      <p class="mt-2 mb-2">${email}</p>
    </div>
    <hr class="mt-1 border mb-1">
    <div class="col-12">
      <p class="mb-0">${org}</p>
      <p class="mb-0">${addr["street"] || ""}</p>
      <p class="mb-0">${addr["zip"] || ""} ${addr["location"] || ""}</p>
      <p class="mb-0">Gebäude: ${employee["building"] || ""}</p>
      <p class="mb-0">Stock: ${employee["floor"] || ""}</p>
      <p class="mb-0">Zimmer: ${employee["room"] || ""}</p>
    </div>
    <div class="col-12 mt-2">
      <a class="text-decoration-none" href="tel:${phone}">
        <div class="btn btn-secondary d-grid gap-2 d-flex justify-content-center align-items-center">
          <div class="icon-phone pe-2"></div><span>Anrufen</span>
        </div>
      </a>
    </div>
    <div class="col-12">
      <div class="row mt-2">
        <div class="col-6">
          <a target="_blank" class="text-decoration-none" href="mailto:${email}">
            <div class="btn bg-gray-400 d-grid gap-2 d-flex justify-content-center align-items-center">
              <div class="icon-envelope pe-2"></div><span>E-Mail</span>
            </div>
          </a>
        </div>
        <div class="col-6">
          <a target="_blank" class="text-decoration-none" href="${website}">
            <div class="btn bg-gray-400 d-grid gap-2 d-flex justify-content-center align-items-center">
              <div class="icon-network-www pe-2"></div><span>Website</span>
            </div>
          </a>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-6">
          <a class="link-dark text-decoration-none" target="_blank" href="https://maps.google.de/maps?daddr=${addr["lat"] || ""}%2C${addr["lon"] || ""}&amp;saddr=My+Location">
            <div class="btn bg-gray-400 d-grid gap-2 d-flex justify-content-center align-items-center">
              <div class="icon-place pe-2"></div><span>Route</span>
            </div>
          </a>
        </div>
        <div class="col-6">
          <div class="btn bg-gray-400 d-grid gap-2 d-flex justify-content-center align-items-center add-to-contact" data-organization="${org}" data-address="${addr["street"] || ""};${addr["location"] || ""};;${addr["zip"] || ""}" data-email="${email}" data-mobile="${fax}" data-phone="${phone}" data-title="${employee["first_name"]} ${employee["last_name"]}" data-firstname="${employee["first_name"]}" data-lastname="${employee["last_name"]}">
            <div class="icon-envelope"></div><span>Zu Kontakten</span>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 mt-3">
      <div class="accordion" id="accordionEmployee${eid}${serviceId}">
        <div class="accordion-item bg-white border-0">
          <h2 class="accordion-header" id="entryheadingAbteilungen${eid}${serviceId}">
            <button aria-controls="entrycollapseAbteilungen${eid}${serviceId}" aria-expanded="false" class="employee-button accordion-button pt-2 pb-2 collapsed" data-bs-target="#entrycollapseAbteilungen${eid}${serviceId}" data-bs-toggle="collapse" type="button">Abteilungen</button>
          </h2>
          <div aria-labelledby="entryheadingAbteilungen${eid}${serviceId}" class="accordion-collapse collapse" data-bs-parent="#accordionEmployee${eid}${serviceId}" id="entrycollapseAbteilungen${eid}${serviceId}">
            <div class="accordion-body row pt-0"><div class="col-12">${departments}</div></div>
          </div>
          <hr class="mt-0 mb-0">
        </div>
        <div class="accordion-item bg-white border-0 mt-3">
          <h2 class="accordion-header" id="entryheadingLeistungen${eid}${serviceId}">
            <button aria-controls="entrycollapseLeistungen${eid}${serviceId}" aria-expanded="false" class="employee-button accordion-button pt-2 pb-2 collapsed" data-bs-target="#entrycollapseLeistungen${eid}${serviceId}" data-bs-toggle="collapse" type="button">Leistungen</button>
          </h2>
          <div aria-labelledby="entryheadingLeistungen${eid}${serviceId}" class="accordion-collapse collapse" data-bs-parent="#accordionEmployee${eid}${serviceId}" id="entrycollapseLeistungen${eid}${serviceId}">
            <div class="accordion-body row pt-0"><div class="col-12"><div class="accordion" id="accordionEmployeesServices${eid}${serviceId}">${entries}</div></div></div>
          </div>
          <hr class="mt-0 mb-0">
        </div>
      </div>
    </div>`;
}

// Fetch an employee's full record the first time their accordion is opened and
// render it into the empty .lazy-employee body. Works for both server-rendered
// (initial page) and JS-rendered (scroll/search) employee rows.
$(document).on('show.bs.collapse', function (e) {
  const body = e.target.querySelector(':scope > .accordion-body.lazy-employee[data-loaded="false"]');
  if (body) loadEmployeeDetail(body);
});

$(document).on('click', '.lazy-employee-retry', function (e) {
  e.preventDefault();
  const body = this.closest('.lazy-employee');
  if (body) loadEmployeeDetail(body);
});

async function loadEmployeeDetail(body) {
  body.setAttribute('data-loaded', 'true'); // guard against a second fetch
  const empId = body.getAttribute('data-employee-id');
  const serviceId = body.getAttribute('data-service-id') || '';
  body.innerHTML = EMP_SPINNER;
  try {
    const resp = await fetch(`/lwconnectapi/v1/employees/${empId}.json`, {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    });
    if (!resp.ok) throw new Error('HTTP ' + resp.status);
    const employee = await resp.json();
    body.innerHTML = generateEmployeeBody(employee, serviceId);
  } catch (err) {
    body.setAttribute('data-loaded', 'false'); // allow a retry
    body.innerHTML = `<div class="col-12 text-center py-3 text-black-50">Details konnten nicht geladen werden. <a href="#" class="lazy-employee-retry">Erneut versuchen</a></div>`;
  }
}

$(document).on('turbo:load', async function () {
  const countElements = {
  service: $(".service_count"),
  employee: $(".employee_count"),
  search_text: $(".search_count_text")
  };

  const linkElements = {
  service: countElements.service.parent("a"),
  employee: countElements.employee.parent("a")
  };

  const extractCount = (text) => {
  const match = text.match(/(\d+)/);
  return match ? parseInt(match[0]) : 0;
  };

  const initCounts = {
  service: extractCount(countElements.service.text()),
  employee: extractCount(countElements.employee.text()),
  service_url: linkElements.service.attr("href"),
  employee_url: linkElements.employee.attr("href")
  };

  const updateCountsAndLinks = (serviceCount, employeeCount, serviceUrl, employeeUrl) => {
  countElements.service.text(`Dienste (${serviceCount})`);
  countElements.employee.text(`Kontakte (${employeeCount})`);
  countElements.search_text.text(`${serviceCount+employeeCount} `+ (serviceCount+employeeCount == 1 ? `Ergebnis` : `Ergebnisse`) + ` für die Suche nach „${$(".searvice_count_search").val()}"` );
  linkElements.service.attr("href", serviceUrl);
  linkElements.employee.attr("href", employeeUrl);
  };

  let countSearchTimeout;
  $(".searvice_count_search").on('input', function() {
  const newValue = $(this).val();
  clearTimeout(countSearchTimeout);
  if (newValue === "") {
    updateCountsAndLinks(
      initCounts.service,
      initCounts.employee,
      initCounts.service_url,
      initCounts.employee_url
    );
    return;
  }
  countSearchTimeout = setTimeout(async () => {
      const suggestions = await loadServicesCount(newValue);
      const serviceUrlWithoutParams = initCounts.service_url.split('?')[0];
      const employeeUrlWithoutParams = initCounts.employee_url.split('?')[0];

      const serviceUrlWithSearch = `${serviceUrlWithoutParams}?search=${newValue}`;
      const employeeUrlWithSearch = `${employeeUrlWithoutParams}?search=${newValue}`;

      updateCountsAndLinks(
        suggestions.data.entries,
        suggestions.data.employees,
        serviceUrlWithSearch,
        employeeUrlWithSearch
      );
    }, 300);
  });


  let searchTimeout;
  $(".employees_search").on('input', async function() {
  const newValue = $(this).val();
  clearTimeout(searchTimeout);
    searchTimeout = setTimeout(async () => {
      // if (!newValue) return;
      window.scrollLoad = false;
      $("#accordionEmployees").empty();
      $("#accordionEmployees").append(SPINNER);
      const suggestions = await loadEmployees(newValue,0);
      countElements.employee.text(`Kontakte (${suggestions.data.pagination.total_entries})`);
      if (newValue){
        countElements.search_text.text(`${suggestions.data.pagination.total_entries} `+ (suggestions.data.pagination.total_entries == 1 ? `Ergebnis` : `Ergebnisse`) + ` für die Suche nach „${newValue}"` );
      }else{
        countElements.search_text.text("Nach Dienst, Kontakt oder Zuständigkeit suchen");
      }
      if (suggestions.data.data.length < 1) {
        window.scrollLoad = false;
        $("#accordionEmployees").append(NORESULTHTML);
      } else {
        const employeeSet = new Set();
        $.each(suggestions.data.data, function(key, employee) {
          if (employeeSet.has(employee.id)) return;
          employeeSet.add(employee.id);
          $("#accordionEmployees").append(generateContactEmployeeHeader(employee));
        });
        window.scrollLoad = true;
      }
      $("#list_loader").remove();
    }, 300);
  });


  $(".entries_search").on('input', async function() {
  const newValue = $(this).val();
  clearTimeout(searchTimeout);
    searchTimeout = setTimeout(async () => {
      // if (!newValue) return;
      $("#accordionServices").empty();
      $("#accordionServices").append(SPINNER);
      const suggestions = await loadServices(newValue, 0);
      countElements.service.text(`Dienste (${suggestions.count})`);
      if (newValue){
        countElements.search_text.text(`${suggestions.count} `+ (suggestions.count == 1 ? `Ergebnis` : `Ergebnisse`) + ` für die Suche nach „${newValue}"` );
      }else{
        countElements.search_text.text("Nach Dienst, Kontakt oder Zuständigkeit suchen");
      }
      if (suggestions.data.length < 1) {
        window.scrollLoad = false;
        $("#accordionServices").append(NORESULTHTML);
      } else {
        $.each(suggestions.data, function(key, service) {
          let employeeHtml = '';
          $.each(service.employees, function(key, employee) {
            employeeHtml += generateServiceEmployeeHeader(employee, service["id"]);
          });
          $("#accordionServices").append(generateEntry(service, employeeHtml));
        });
      }
      $("#list_loader").remove();
    }, 300);
  });

});
